import { useState, useEffect, useRef, Suspense, useContext } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./layout/Login";
import Modal from "./layout/Modal";
import Form from "./controls/Form";
import Input from "./controls/Input";
import Header from "./layout/Header";
import Api from "./api/Api";
import { AccountContext } from "./Account/AccountContext";
import Users from "./Users/Users";
import { useNavigate } from "react-router";
import "../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.cs.js";
import CategoryList from "./Categories/CategoryList";
import Cards from "./Cards/Cards";
import Requests from "./Cards/Requests";

export default function App() {

	const navigate = useNavigate();
	const [navigateSet, setNavigateSet] = useState(false);
	const { account, logout } = useContext(AccountContext);
	const modalProfile = useRef();
	const formProfile = useRef();

	useEffect(() => {
		if (navigateSet) // hack, [navigate] vola useEffect dvakrat, prvni nefunguje
			Api.addListener(onApiResponse);
		setNavigateSet(true);
	}, [navigate]);

	if (!navigateSet) return false;

	const onApiResponse = (response) => {
		if (response.status == 401) {
			logout();
		}
		//    if (response.data.impersonating) {
		//        setRedirect('/');
		//        onLogin(response);
		//    }
		if (response.data.redirect) {
			navigate(response.data.redirect);
			return false;
		}
		return true;
	}

	const NotLogggedIn = () => {
		let hash = 'none';
		if (window.location.search.startsWith('?hash='))
			hash = window.location.search.substring(6);

		return <Routes>
			<Route path="/resetpassword" element={<Login key='rst' hash={hash} resetPassword />} />
			<Route path="*" element={<Login />} />
		</Routes>
	}

	const RedirDefault = () => {
		navigate("/cards/");
	}

	const LoggedIn = () => {
		return (
			<>
				<Header modalProfile={modalProfile} />
				<div id="pageContent" className="container">
					<Routes>
						{account.isAdmin && <Route path="/users/*" element={<Users />} />}
						{account.isAdmin && <Route path="/categories/:type" element={<CategoryList />} />}
						<Route path="/cards/*" element={<Cards />} />
						<Route path="/requests/*" element={<Requests />} />
						<Route path="/" element={<RedirDefault />} />
					</Routes>
					<Modal title={account.firstName + " " + account.lastName} ref={modalProfile}>
						<Form action="account/update" onSuccess={() => modalProfile.current.close()} ref={formProfile}>
							<fieldset>
								<legend>{t.loginChangePassword}</legend>
								<Input name="OldPassword" label={t.loginOldPassword} type="password" value="" />
								<Input name="NewPassword" label={t.loginNewPassword} type="password" value="" />
								<button type="submit" className="btn btn-primary float-end mt-2">{t.commonSend}</button>
							</fieldset>
						</Form>
					</Modal>
				</div>
			</>
		)
	}

	return account == null ? false : account == false ? <NotLogggedIn /> : <LoggedIn />
}